import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { shallowEqual, useSelector } from 'react-redux';

import Modal from '../../../components/Modal/Modal';
import { IconArrowRight, IconLoading } from '../../../assets/icon';
import { getEbayCategoryPath } from '../../../utils/helpers';

const categoryListContainerClassName = 'max-w-[700px] overflow-auto';
const categoryListColumnContainerClassName = 'min-w-[1200px]';
const categoryListColumnContainerLvl3ClassName = 'min-w-[700px]';
const categoryListColumnClassName = 'max-h-[350px] overflow-y-auto overflow-x-hidden';
const listItemBaseClassName = [
  'text-[13px] text-text-second px-[13px] py-[9px] rounded-[5px] cursor-pointer',
  'hover:text-primary hover:bg-[#f4f6fa] flex flex-row items-center justify-between'
].join(' ');
const listItemActiveClassName = 'text-primary bg-[#f4f6fa]';

const EbayCategoryModal = ({
  visible, toggleVisible, setFieldValue, preSelectedCategory
}) => {
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedLeafCategory, setSelectedLeafCategory] = useState(null);
  const {
    ebayCategoryList, ebayCategoryLoading
  } = useSelector((state) => ({
    ebayCategoryList: state?.getEbayCategoryList?.list,
    ebayCategoryLoading: state?.getEbayCategoryList?.loading,
  }), shallowEqual);

  useEffect(() => {
    if (preSelectedCategory && ebayCategoryList) {
      const path = getEbayCategoryPath(ebayCategoryList, preSelectedCategory);
      const preSelectPath = path.reduce((previousValue,
        {
          categoryLevel: lvl, categoryId: id, categoryName: title, leafCategory: leaf
        } = {}) => {
        if (lvl > 1) {
          return {
            ...previousValue,
            [lvl]:
                {
                  id, lvl, title, leaf
                }
          };
        }
        return {};
      }, {});
      setSelectedCategory(preSelectPath);
    }
  }, [preSelectedCategory, ebayCategoryList]);

  const onSelectCategory = (category) => {
    const { lvl, leaf } = category;
    setSelectedLeafCategory(leaf ? category : null);

    const temp = selectedCategory;
    Object?.keys(selectedCategory)?.reduce((previousValue, currentValue) => {
      if (currentValue > lvl) {
        delete temp[currentValue];
      }
      return currentValue;
    }, 2);
    setSelectedCategory({ ...temp, [lvl]: category });
  };

  const listItem = (category) => (
    <li
      key={category.id}
      className={`${listItemBaseClassName} ${
        selectedCategory[category?.lvl]?.id === category?.id ? listItemActiveClassName : ''
      }`}
      role="presentation"
      onClick={() => onSelectCategory(category)}
    >
      {category.title}
      {!category.leaf && <IconArrowRight />}
    </li>
  );

  const filterCategory = (selectId, selectLvl) => ebayCategoryList?.filter(
    ({ categoryLevel, categoryParentID }) => categoryLevel === selectLvl
          && categoryParentID === selectId
  );

  const colClass = `${categoryListColumnClassName} customScroll`;

  const getSubtitle = () => {
    let path = [];
    if (selectedLeafCategory) {
      path = Object?.keys(selectedCategory)?.map(
        (lvl) => selectedCategory[lvl]?.title
      );
    }
    return path.join(' > ');
  };

  const onSave = () => {
    setFieldValue('category', selectedLeafCategory?.id);
    toggleVisible();
  };

  return (
    <Modal
      visible={visible}
      toggleVisible={toggleVisible}
      title="Create new article theme"
      subTitle={getSubtitle()}
      saveText="Select"
      canSave={!selectedLeafCategory}
      hideCloseBtn
      onSave={onSave}
    >
      {ebayCategoryLoading ? (
        <div
          className="d-flex d-item-center d-justify-center spin"
        >
          <IconLoading />
        </div>
      )
        : (
          <div className={categoryListContainerClassName}>
            <div className={`flex flex-row ${
              Object.keys(selectedCategory).length > 2
                ? categoryListColumnContainerClassName
                : categoryListColumnContainerLvl3ClassName
            }`}
            >
              <div className={colClass}>
                <ul>
                  {
                filterCategory(6000, 2)?.map(({
                  categoryId: id,
                  categoryLevel: lvl,
                  categoryName: title,
                  leafCategory: leaf
                }) => listItem({
                  id, lvl, title, leaf
                }))
              }
                </ul>
              </div>
              {Object.keys(selectedCategory)?.map((selectedLvl) => (
                <div className={colClass} key={selectedLvl}>
                  <ul>
                    {filterCategory(selectedCategory[selectedLvl]?.id, parseInt(selectedLvl) + 1)
                      ?.map(({
                        categoryId: id,
                        categoryLevel: lvl,
                        categoryName: title,
                        leafCategory: leaf
                      }) => listItem({
                        id, lvl, title, leaf
                      }))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        )}
    </Modal>
  );
};

EbayCategoryModal.propTypes = {
  visible: PropTypes.bool,
  toggleVisible: PropTypes.func,
  setFieldValue: PropTypes.func,
  preSelectedCategory: PropTypes.number,
};

EbayCategoryModal.defaultProps = {
  visible: false,
  toggleVisible: () => {},
  setFieldValue: () => {},
  preSelectedCategory: null,
};

export default EbayCategoryModal;
